// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
import keyMirror from 'mattermost-redux/utils/key_mirror';

export default keyMirror({
    DISMISS_ERROR: null,
    LOG_ERROR: null,
    CLEAR_ERRORS: null,
    RESTORE_ERRORS: null,
});
